import decoder from '../../../lib/decoder';

function ModelTariff() {
	this.id = 0;
	this.name = '';
	this.description = '';
}

ModelTariff.create = function (json) {
	if (!json) json = {};
	
	let model = new ModelTariff();
	
	model.id = decoder.intValue(json['id'], 0);
	model.name = decoder.stringValue(json['name'], '');
	model.description = decoder.stringValue(json['description'], '');
	
	return model;
};

export default ModelTariff;